import {
  GET_OFFERS_FAIL,
  GET_OFFERS_REQUEST,
  GET_OFFERS_SUCCESS,
  GET_OFFERS_PRODUCT_REQUEST,
  GET_OFFERS_PRODUCT_SUCCESS,
  GET_OFFERS_PRODUCT_FAIL,
  ADD_OFFERS_REQUEST,
  ADD_OFFERS_SUCCESS,
  ADD_OFFERS_FAIL,
  GET_OFFER_REQUEST,
  GET_OFFER_SUCCESS,
  GET_OFFER_FAIL
} from "./type";

// category intial state
const initialOffers = {
  offers: [],
  offer: null,
  productDropdownList: [],
  isLoading: false,
  error: null,
  total: null,
  isSingleLoading: false
};

export const reducer = (state = initialOffers, action) => {
  switch (action.type) {
    case GET_OFFERS_REQUEST:
      return { ...state, isLoading: true };
    case GET_OFFERS_SUCCESS: {
      const offersData = action?.payload?.data?.records || [];
      return {
        ...state,
        offers: offersData,
        isLoading: false,
        total: action?.payload?.data?.totalRecord || 0
      };
    }
    case GET_OFFERS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case GET_OFFER_REQUEST:
      return { ...state, isLoading: true };
    case GET_OFFER_SUCCESS: {
      const offersData = action.payload.data;
      return {
        ...state,
        offer: offersData,
        isLoading: false
      };
    }
    case GET_OFFER_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case GET_OFFERS_PRODUCT_REQUEST:
      return { ...state, isLoading: true };
    case GET_OFFERS_PRODUCT_SUCCESS: {
      const offersData = action.payload.data;
      return {
        ...state,
        productDropdownList: offersData,
        isLoading: false
      };
    }
    case GET_OFFERS_PRODUCT_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case ADD_OFFERS_REQUEST:
      return { ...state, isLoading: true };
    case ADD_OFFERS_SUCCESS:
      return { ...state, isLoading: false };
    case ADD_OFFERS_FAIL:
      return { ...state, isLoading: false, error: action.error };

    default:
      return state;
  }
};
